export const ANALYTICS_ENABLED_LS_KEY = 'analyticsEnabled';
export const APP_CHAIN_ID_LS_KEY = 'appChainId';
export const CURRENT_THEME_LS_KEY = 'currentTheme';
export const FAVORITE_PAIRS_LS_KEY = 'favoritePairs';
export const IS_NOT_FIRST_LAUNCH_LS_KEY = 'isNotFirstLaunch';
export const IS_SHOWN_CHANGE_NETWORK_POPUP_LS_KEY = 'isShownChangeNetworkPopup';
export const LANGUAGE_LS_KEY = 'language';
export const THEME_LS_KEY = 'theme';
export const WALLET_ADDRESS_LS_KEY = 'walletAddress';
export const WALLET_CHAIN_ID_LS_KEY = 'walletChainId';
export const WALLET_TYPE_LS_KEY = 'walletType';
export const WALLETCONNECT_LS_KEY = 'walletconnect';
